export const USER_ROLES = {
  BOARD_LEVEL: "Board Level",
  REGIONAL_MD: "Regional MD",
  SENIOR_ESTIMATOR: "Senior Estimator",
  COMMERCIAL_DIRECTOR: "Commercial Director",
  COMMERCIAL_MANAGER: "Commercial Manager",
  CONTRACTS_MANAGER: "Contracts Manager",
  QS_QUANTITY_SURVEYOR: "QS (Quantity Surveyor)",
  PROJECT_MANAGER: "Project Manager",
  ESTIMATOR: "Estimator",
  SITE_MANAGER_SUPERVISOR: "Site Manager/Supervisor",
  CONTRACTS_DIRECTOR: "Contracts Director",
  SYSTEM_ADMINISTRATOR: "System Administrator"
};
